import Swiper, {Lazy, Pagination, Autoplay} from 'swiper';
Swiper.use([Lazy, Pagination, Autoplay]);

export default class LayoutLightboxImages {
  private el: {
    body: HTMLElement,
    main: HTMLElement,
    btClose: HTMLElement,
    buttons: NodeListOf<HTMLElement>,
    itemsContainer: HTMLElement,
    paginationContainer: HTMLElement,
    btNext: HTMLElement,
    btPrev: HTMLElement,
  };

  private className = {
    active: 'lightbox-images-is-open',
    hasMultipleItems: 'has-multiple-items',
  };

  private isOpen = false;

  private swiperCarousel: Swiper | null;

  private time = 5000;

  private cache() {
    this.el = {
      body: document.body,
      main: document.querySelector('#js-l-li') as HTMLElement,
      btClose: document.querySelector('#js-l-li__bt-close') as HTMLElement,
      itemsContainer: document.querySelector('#js-l-li__items') as HTMLElement,
      paginationContainer: document.querySelector('#js-l-li__pag') as HTMLElement,
      buttons: document.querySelectorAll('[data-lightboximages]'),
      btNext: document.querySelector('#js-l-li__bt-prev') as HTMLElement,
      btPrev: document.querySelector('#js-l-li__bt-prev') as HTMLElement,
    }
  }

  private bindings() {
    const { el } = this;

    el.buttons.forEach(
      (elButton) => {
        elButton.addEventListener(
          'click', () => this.open(String(elButton.dataset.lightboximages))
        );
      }
    );

    el.btClose?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') this.close();
    });
  }

  private open(images: string) {
    const { el, className} = this;

    let htmlItems = '';
    const arrImages = JSON.parse(images) as Array<{image: {url: string}}>;
    arrImages.forEach((item: any, index: number) => {
      htmlItems += `
        <div class='swiper-slide'>
          <img data-src='${item.image.url}' class='swiper-lazy' decoding='async' loading='lazy' />
          <div class='swiper-lazy-preloader swiper-lazy-preloader-white'></div>
        </div>`;
    });

    el.itemsContainer.innerHTML = `<div class='swiper-wrapper'>${htmlItems}</div>`;

    const hasMultipleItems = arrImages.length > 1;
    el.main.classList.toggle(className.hasMultipleItems, hasMultipleItems);

    this.swiperCarousel = new Swiper(el.itemsContainer, {
      preloadImages: false,
      grabCursor: hasMultipleItems,
      loop: hasMultipleItems,
      speed: 800,
      autoplay: {
        delay: this.time,
      },
      lazy: {
        loadPrevNext: true,
      },
      pagination: hasMultipleItems ? {
        el: el.paginationContainer,
        type: 'bullets',
        clickable: true,
      }: false,
      navigation: hasMultipleItems ? {
        nextEl: el.btNext,
        prevEl: el.btPrev,
      } : false,
      on: hasMultipleItems ? {
        afterInit: () => {
          el.paginationContainer?.style.setProperty('--time', `${this.time / 1000}s`);
        },
      } : undefined,
    });
    this.swiperCarousel.lazy.load();

    el.body.classList.add(className.active);
    this.isOpen = true;
  }

  private close() {
    const { el, className} = this;

    if (this.isOpen === true) {
      el.body.classList.remove(className.active);
      this.isOpen = false;
      if (this.swiperCarousel) {
        this.swiperCarousel.destroy();
        this.swiperCarousel = null;
      }
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}
